import { useAuth } from "./authContext";

const Permission = ({ code, children,  fallback = null }) => {
    
    const { permissions } = useAuth();

    if (!permissions) return fallback;

    if (permissions.includes(code) || permissions.includes("fullAccess")) {

        return children;

    }

    return fallback;
};

export default Permission;
